export function squareMetersToHectares(squareMeters, decimals = 2) {
    if (!squareMeters || isNaN(squareMeters)) {
        return '0 ha'
    }
    
    const hectares = squareMeters / 10000 // 1 hectare = 10000 square meters
    return `${hectares.toFixed(decimals)} ha`
}

export function metersToKilometers(meters, decimals = 2) {
    if (!meters || isNaN(meters)) {
        return '0 km'
    }
    
    const kilometers = meters / 1000
    return `${kilometers.toFixed(decimals)} km`
}